import { UserProfileDTO } from "../../Api/Model";
import { AppState } from "../root-reducer";

export const selectUser = (state: AppState): UserProfileDTO | undefined => state.userReducer.user;

export const selectContentLicenses = (state: AppState) => state.userReducer.user?.contentLicenses.sort((a,b) => (+b.isDefault) - (+a.isDefault) || a.txtLicenseName.localeCompare(b.txtLicenseName));
export const selectApprovalLicenses = (state: AppState) => state.userReducer.user?.approvalLicenses.sort((a,b) => (+b.isDefault) - (+a.isDefault) || a.txtLicenseName.localeCompare(b.txtLicenseName));